import { connect } from 'react-redux';
import SideDockVisitorWidget from '../components/SideDockVisitorWidget';
// @ts-expect-error untyped file
import { republishMessage } from '../../actions/PublishActions/republishMessage';
import { getChatHeadingConfig } from '../../chat-heading-config/selectors/getChatHeadingConfig';
// @ts-expect-error untyped file
import { showAvailabilityMessageInWidget } from '../../availability/selectors/showAvailabilityMessageInWidget';
import { getAvailabilityOfficeHoursWillReturnMessage } from '../../availability/selectors/getAvailabilityOfficeHoursWillReturnMessage';
// @ts-expect-error untyped file
import { getAvailabilityTypicalResponseTimeMessage } from '../../availability/selectors/getAvailabilityTypicalResponseTimeMessage';
import { navigateToStagedThread } from '../../navigation/actions/navigateToStagedThread';
import { getAssignedResponderInWidget } from '../../responders/selectors/getAssignedResponderInWidget';
// @ts-expect-error untyped file
import { getChatHeadingResponders } from '../../responders/selectors/getChatHeadingResponders';
import { getColoring } from '../../selectors/widgetDataSelectors/getColoring';
// @ts-expect-error untyped file
import { getSelectedThread } from '../../selected-thread/selectors/getSelectedThread';
import { restorePreviousViewFromKBArticle } from '../../navigation/actions/restorePreviousViewFromKBArticle';
import { navigateToThreadList } from '../../navigation/actions/navigateToThreadList';
import { navigateToKnowledgeBaseArticle } from '../../navigation/actions/navigateToKnowledgeBaseArticle';
import { isCreatingThread } from '../../thread-create/selectors/stagedThreadSelectors';
import { toggleWidgetSizeForKBArticle } from '../../kb-article/actions/toggleWidgetSizeForKBArticle';
import { getKBArticle, getShouldViewKBArticleExpanded } from '../../kb-article/kbArticleSelectors';
import { updateView } from '../../current-view/actions/updateView';
import { getCustomHeaderText } from '../../current-view/operators/getCustomHeaderText';
import { getKBNavigationEnabled } from '../../navigation/selectors/getKBNavigationEnabled';
import { isStarted } from '../../threads/operators/isStarted';
import { isClosed } from '../../threads/operators/isClosed';
import { isPersistedThread } from '../../threads/operators/isPersistedThread';
import { endCurrentThread } from '../../threads/actions/endCurrentThread';
import { getIsUngatedForCloseThread } from '../../widget-data/selectors/widgetDataSelectors';
// @ts-expect-error untyped file
import { calculateUnseenThreadsCountExcludeCurrent } from '../../threads/selectors/calculateUnseenThreadsCountExcludeCurrent';
// @ts-expect-error untyped file
import { getShowBackButton } from '../../threads/selectors/getShowBackButton';
import { setWidgetSize as setWidgetSizeAction } from '../../widget-size/widgetSizeSlice';
const mapStateToProps = (state, ownProps) => {
  const kbArticleData = getKBArticle(state);
  const selectedThread = getSelectedThread(state);
  return {
    widgetSize: ownProps.widgetSize,
    chatHeadingConfig: getChatHeadingConfig(state),
    chatHeadingResponders: getChatHeadingResponders(state),
    coloring: getColoring(state),
    customHeaderText: getCustomHeaderText(state),
    isThreadAssigned: Boolean(getAssignedResponderInWidget(state)),
    isThreadStarted: isStarted(selectedThread),
    isThreadClosed: isClosed(selectedThread),
    isThreadPersisted: isPersistedThread(selectedThread),
    officeHoursMessage: getAvailabilityOfficeHoursWillReturnMessage(state),
    showAvailabilityMessage: showAvailabilityMessageInWidget(state, {
      thread: selectedThread
    }),
    showBackButton: getShowBackButton(state),
    backButtonDisabled: isCreatingThread(state),
    typicalResponseTimeMessage: getAvailabilityTypicalResponseTimeMessage(state),
    unseenThreadsCountExcludingCurrentThread: calculateUnseenThreadsCountExcludeCurrent(state),
    viewKBArticleExpanded: getShouldViewKBArticleExpanded(state),
    kbArticleDeepLink: kbArticleData.deepLink,
    kbNavigationEnabled: getKBNavigationEnabled(state),
    isUngatedForCloseThread: getIsUngatedForCloseThread(state)
  };
};
const mapDispatchToProps = {
  fetchAgentResponderIfNecessary: () => {},
  createNewThread: navigateToStagedThread,
  endChat: endCurrentThread,
  republishMessage,
  navigateBack: navigateToThreadList,
  navigateToKnowledgeBaseArticle,
  restorePreviousViewFromKBArticle,
  toggleWidgetSizeForKBArticle,
  updateView,
  setWidgetSize: setWidgetSizeAction
};
export default connect(mapStateToProps, mapDispatchToProps)(SideDockVisitorWidget);